export default "__VITE_ASSET__DPSFDWsb__"